import { type CSSObject } from "@emotion/react";
import { constants, mediaQueryStyles } from "@newsela/angelou";

const { mediaQuery } = mediaQueryStyles;
const { breakpoints, colors } = constants;
const { xs } = breakpoints.BreakpointNames;

const darkBlue = colors.ui.core[700];

export const rootCss: CSSObject = {
  fontWeight: "bold",
  textTransform: "uppercase",
  letterSpacing: "1px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "10px 40px",
  h6: {
    margin: 0,
  },
  height: "80px",
};

export const controlsCss: CSSObject = {
  display: "flex",
  alignItems: "center",
  padding: "0 20px",
  gap: "16px",

  [mediaQuery.upTo(xs)]: {
    flex: "1",
    justifyContent: "unset",
  },
};

export const buttonCss: CSSObject = {
  backgroundColor: "transparent",
  padding: "8px 8px",
  height: "35px",
  width: "35px",

  svg: {
    margin: 0,

    path: {
      stroke: darkBlue,
      "&:nth-child(2)": {
        fill: darkBlue,
      },
    },
  },

  rect: {
    fill: darkBlue,
  },
};

export const restartIconCss: CSSObject = {
  width: "18px",
};

export const toggleAudioIconCss: CSSObject = {
  width: "18px",

  path: {
    fill: darkBlue,
  },
};
